<template>
	<div>
		<iframe
			v-bind:id="'thumbnail'+dir"
			class="thumbnail"
			:alt="dir"
		></iframe>
		<p v-if="techdoc_id!=undefined" class="subtext">{{techdoc_id}}</p>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		dir: String,
		id: {
			type: Number,
			required: false,
			default: -1
		},
		techdoc_id: String,
		pageid:Number,
    },
	data() {
		return {

		}
	},
	mounted () {
		let stateCheck = setInterval(() => {
			if (document.getElementById("thumbnail"+this.dir)!=null) {
				clearInterval(stateCheck);
				this.setTechdoc();
			}
		}, 100);
	},
	methods:{
		async setTechdoc(){
			api.getTechdoc(
                {
					data:{
						pageid:this.pageid,
						techdocsid:this.id
					}
                }
            ).then((res) => {
				var embed = document.getElementById("thumbnail"+this.dir);

				var filetype = res.data.filetype
				if(filetype=='jpg'||filetype=='png'||filetype=='jpeg'){
					embed.src="data:image/png;base64, "+res.data.imageData;
				}else if(filetype=='pdf'){

					var base64 = res.data.imageData
					var type = 'application/pdf'

					var binStr = atob( base64 );
					var len = binStr.length;
					var arr = new Uint8Array(len);
					for (let i = 0; i < len; i++) {
						arr[ i ] = binStr.charCodeAt( i );
					}
					var blob = new Blob( [ arr ], { type: type } );

					embed.src = URL.createObjectURL(blob)
				}

				this.$emit('load',  res.data.filename, res.data.notes);
	        });
		},
	},
	watch:{
		dir(){
			this.setTechdoc();
		},
		id(){
			this.setTechdoc();
		},
		techdoc_id(){
			this.setTechdoc();
		},
	},
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
}

.thumbnail{
	width:100%;
	height:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/techdoc.vue